angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsDashboardCell', function ($log, EventManager, TeacherDataService) {return {
  templateUrl: 'template.html',
  scope: {
    stats: '=',
    module: '='
  },
  link: function(scope){
    var eventManager = new EventManager('teacherStudentsDashboardCell', scope);
    scope.getProgressRing = function(size, score, lock){
        var url = 'https://s3.eu-central-1.amazonaws.com/mtic-items/interface/';
        if (lock){
          url += 'teachview-ring-'+size+'-locked.png'
        }
        else{
          var num = score ? Math.min(21 , Math.round(21*score)) : 0;
          if (num === 0){
            url += 'teachview-ring-'+size+'-blank.png'
          }
          else{
            if ( String(num).length === 1){
              num = '0'+num;
            }
            url += 'teachview-ring-'+size+'-fill00'+num+'.png'
          }
        }
        return url;
      }
  }
}})
